import React from "react";
import { Trans } from "react-i18next";
import { Card, H3, Elevation, Callout } from "@blueprintjs/core";

export default class Gamme400 extends React.Component {

  constructor() {
    super();
    this.state = {
      selected: "none"
    };
  }

  render() {
    var description;
    switch (this.state.selected) {
      case "CA":
        description = <Card>
          <H3><Trans>LCA 460 et LCB 460</Trans></H3>
          <Callout title="Caisse automatique tout usage">
            <p>
              La nouvelle gamme est conçue pour optimiser l’exploitation
              et la maintenance ce qui lui confère une disponibilité
              optimale. (coût de possession optimisée).
              Le stockage des données sur carte mémoire flash industrielle
              et l’utilisation de la technologie des processeurs multi-coeurs
              récents contribue  à améliorer la fiabilité de la solution.
            </p>
            <p>
              Une  continuité  de  service  performante  est  obtenue  grâce  à
              la gestion  des modes dégradés transparente pour l’usager.
              La  caisse  LCA  460  est  compacte  et  sécurisée  par    ses  deux
              portes distinctes dont une réservée au compartiment
              fiduciaire. Equipée d’une dalle tactile en option, elle peut se
              substituer à une caisse manuelle.
            </p>
            <p>
              Les  caisses  peuvent  être  exploitées  en  intérieur  comme  en
              extérieur.
            </p>
            <p>
              Les logiciels s’exécutent dans un environnement Linux
              embarqué qui garantit une grande disponibilité.
            </p>

            <Callout icon="cog" title="Caractéristiques techniques">
              <ul>
                <li>Conformité : CE, PHMR DGUHC2007-53</li>
                <li> IP44 </li>
                <li>Poids : 135 kg</li>
                <li>Consommation : 850 VA (avec chauffage activé)</li>
                <li>Dimensions en cm :
                  <ul>
                    <li>hauteur = 155</li>
                    <li>largeur = 70 (LCA) ou 39 (LCB)</li>
                    <li>profondeur = 45</li>
                  </ul>
                </li>
                <li>Température : -10°C à 50°C</li>
              </ul>
            </Callout>

            <Callout title="Fonctionalités standard">
              <Callout title="Matériel">
                <ul>
                  <li>Chassis en acier protégé par cataphorèse, et peinture cuite au four (couleurs standards RAL 7001 et RAL 7024)</li>
                  <li>Ecran 12’’ en standard et 17’’ en option</li>
                  <li>Lecteur / Encodeur de titres QR code ou à pistes magnétiques ISO</li>
                  <li>Monnayeur 5 pièces acceptées et recyclées (LCA460)</li>
                  <li>Haut-parleur, micro et bouton poussoir pour dialogue interphonie (support client 1er niveau)</li>
                </ul>
              </Callout>

              <Callout title="Fonctionnel">
                <ul>
                  <li>Gestion multi tarif</li>
                  <li>Conforme à la loi sur la T VA ainsi qu’à la loi sur la protection des données personnelles RGPD</li>
                  <li>Affichage tarif écran</li>
                  <li>Fonctionnement autonome (mémorisation des données nécessaires au traitement des transactions en temps différé)</li>
                  <li>Activation du forfait «ticket perdu» à distance</li>
                </ul>
              </Callout>
            </Callout>

            <Callout title="Options disponibles">
              <ul>
                <li>Lecteur de billets avec empileur et module de recyclage pour rendu en billets (LCA 460)</li>
                <li>Dalle tactile pour fonctions «caisse manuelle» et vente «multi produits», retrait de réservation</li>
                <li>Lecteur «sans contact» conformes aux standards ISO 14443 A et B (renouvellement de contrat et dépassement abonnées)</li>
                <li>Poste secondaire de phonie spécifique (IP, SIP)</li>
                <li>Affichage d’information type Infotrafic</li>
                <li>Emission de duplicata ticket d’entrée via lecture de plaques minéralogiques</li>
                <li>Caméra intégrée</li>
                <li>Boucle Inductive pour Malentendants</li>
                <li>Interface GTC par entrées / sorties TOR ou par protocole</li>
                <li>Acceptation carte bancaire avec traitement puce (suivant norme EMV )</li>
                <li> Acceptation cartes American Express et Total GR</li>
                <li>Acceptation en contrôle d’accès des cartes partenaires (Cofinoga, Cetelem...)</li>
                <li>Paiement par chèque parking (nombre paramétrable), carte à décompte et tickets bonifiés</li>
                <li>Gestion de la fidélisation et réservation (code barre, GR code)</li>
                <li>Couleurs spécifiques, du chassis sur commande</li>
                <li>Contrôle barrière Ethernet/IP</li>
                <li>Gère la gratuité multi-serveur Thales</li>
              </ul>
            </Callout>
          </Callout>
        </Card>
        break;
      case "BE":
        description = <Card>
          <H3>LES 400</H3>
          <Callout title="Borne de contrôle de tous les usagers en entrée et en sortie">
            <p>
              La nouvelle gamme est conçue pour optimiser l’exploitation
              et la maintenance ce qui lui confère une disponibilité
              optimale. (coût de possession optimisée).
              Le stockage des données sur carte mémoire flash industrielle
              et l’utilisation de la technologie des processeurs multi-coeurs
              récents contribue  à améliorer la fiabilité de la solution.
            </p>
            <p>
              Une  continuité  de  service  performant  est  obtenue  grâce  à
              la  présence  des  2  bacs  de  tickets/reçus  avec  basculement
              automatique sans perte de consommables et à la gestion des
              modes dégradés transparente pour l’usager
            </p>
            <p>
              LES  400  est  compacte  et  offre  une  excellente  accessibilité
              grâce à des ouvrants sur 2 faces.
              LES 400 peut être exploitée en intérieur comme en extérieur.
            </p>
            <p>
              Les logiciels s’exécutent dans un environnement Linux
              embarqué qui garantit une grande disponibilité.
            </p>

            <Callout icon="cog" title="Caractéristiques techniques">
              <ul>
                <li>Grande  qualité  de  fabrication,  emploi  exclusif  de  l’acier, pour une durée de vie sans équivalent.</li>
                <li>Conformité : CE, PHMR DGUHC2007-53</li>
                <li> IP44 </li>
                <li>Poids : 55 kg</li>
                <li>Consommation : 250 VA (avec chauffage activé)</li>
                <li>Dimensions en cm :
                  <ul>
                    <li>hauteur = 132</li>
                    <li>largeur = 35</li>
                    <li>profondeur = 46</li>
                  </ul>
                </li>
                <li>Température : -10°C à 55°C</li>
              </ul>
            </Callout>

            <Callout title="Fonctionalités standard">
              <ul>
                <li>Chassis en acier protégé par cataphorèse, et peinture cuite au four (couleurs standards RAL 7001 et RAL 7024)</li>
                <li>Ecran TFT 7"</li>
                <li>Lecteur/Encodeur de titres QR code ou à pistes magnétiques ISO</li>
                <li>Haut-parleur, micro et bouton poussoir pour dialogue interphonie (support client 1er niveau)</li>
                <li>Gestion des visiteurs et des abonnés</li>
                <li>Fonctionnement autonome (mémorisation des données nécessaires au traitement des transactions en temps différé)</li>
                <li>Activation du forfait «ticket perdu» de l’usager à distance (en sortie) sur appel du conducteur</li>
              </ul>
            </Callout>

            <Callout title="Options disponibles">
              <Callout title="Entrée et Sortie">
                <ul>
                  <li>Couleurs spécifiques</li>
                  <li>Lecteur «sans contact» NFC 14443 (A,B)</li>
                  <li>Connexion à un système de reconnaissance de plaques d'immatriculation</li>
                  <li>Poste secondaire de phonie spécifique (IP, SIP)</li>
                  <li>Caméra intégrée</li>
                  <li>Boucle Inductive pour Malentendants</li>
                  <li>Ecran visiophonie</li>
                  <li>Interface GTC par entrées / sorties TOR</li>
                  <li>Interface Liber’t</li>
                  <li>Gestion de la fidélisation de l’usager</li>
                  <li>Acceptation en contrôle d’accès des cartes partenaires</li>
                  <li>Système BLE</li>
                </ul>
              </Callout>
              <Callout title="Entrée">
                <ul>
                  <li>Accès par Carte Bancaire « sans contact »</li>
                  <li>Clavier ou lecteur QR code pour gestion des réservations via le web</li>
                  <li>Contrôle de passage effectif du véhicule (anti-fraude)</li>
                  <li>  Différentiation VL, PL, Motos + camping car</li>
                </ul>
              </Callout>
              <Callout title="Sortie">
                <ul>
                  <li>Contrôle et paiement avec carte bancaire EMV MPAP</li>
                  <li>Paiement par American Express et Total GR</li>
                  <li>Paiement par bon de stationnement et/ou carte à décompte</li>
                </ul>
              </Callout>
            </Callout>
          </Callout>
        </Card>
        break;
      case "LP":
        description = <Card>
          <H3>LLP 400</H3>
          <Callout title="Lecteur piéton">
            Le  lecteur  d’accès  privatif  LLP  400  est  le  complément
            idéal  de  l’équipement  de  contrôle  d’accès  parking.  Il
            permet  le  contrôle  d’accès  aux  différentes  zones  d’un
            parking et offre de multiples possibilités aux exploitants
            comme le contrôle d’une porte pour la sécurisation du
            parc, le contrôle d’accès d’une zone privative, l’accès de
            nuit pour une catégorie d’usagers ou le contrôle d’accès
            en  sortie  de  parc  lorsque  la  fonction  paiement  est
            effectuée en caisse automatique ou via une application
            smartphone. Ce lecteur peut être utilisé indifféremment
            pour contrôler l’accès des piétons ou celui des véhicules.
            Il peut fonctionner en mode autonome pour un
            contrôle  d’accès  simple  ou  raccordé  au  serveur  parc
            afin d’assurer les contrôles usuels des titres (validité de
            lieu, de temps, de présence, etc...). Dans ce dernier cas, le
            LLP 400 est géré par l’exploitant comme un équipement
            de parking.
          
          <Callout icon="plus" title="Ses points forts">
            <p>
              Le faible encombrement du LLP 400 et son
              ergonomie parfaitement étudiée offrent aux
              exploitants  la  possibilité  de  l’installer  dans  tous
              les  environnements.  Le  LLP  400  intègre  sous  un
              faible volume un large éventail de fonctionnalités
              qui viennent s’ajouter pour délivrer une solution
              optimisée à son environnement d’utilisation :
            </p>
            <ul>
              <li>
                Lecture et validation de titres QR code, lecteur de titres "sans
                contact" NFC 14443 A/B
              </li>
              <li>
                Communication - poste secondaire de phonie
                spécifique (IP, SIP)
              </li>
              <li>
                Gestion d’accès - commande de contacts
                pour piloter une barrière ou une porte
              </li>
            </ul>
            <p>
              Configurable et flexible, le lecteur d’accès privatif
              peut  s’utiliser  en  mode  connecté  ou  autonome.
              En mode connecté, il bénéficie de toutes les
              fonctionnalités  de  contrôle  de  tout  équipement
              de la gamme.
            </p>
          </Callout>

          <Callout>
            <p>
              Il  devient  l’équipement  complémentaire  à  une
              borne d’entrée ou de sortie pour toutes les
              fonctions de contrôle d’accès adressées aux
              usagers horaires ou aux abonnés. En mode
              autonome,  il  autorise  les  contrôles    du  parc  et
              gère les catégories d’usagers.
            </p>
          </Callout>

          <Callout icon="cog" title="Caractéristiques techniques">
            <ul>
              <li>Dimensions en mm :
                <ul>
                  <li>hauteur = 270</li><li> largeur = 165</li><li> profondeur = 120</li>
                </ul>
              </li>
              <li>Poids : 2,5 kg</li>
              <li>Alimentation : 100 VA en version de base</li>
              <li>Température opérationnelle : -20 à +50°C</li>
            </ul>
          </Callout>

          <Callout title="Fonctionalités standard">
            <ul>
              <li>
                QR code et/ou sans contact
              </li>
              <li>
                Gestion de la présence d’un véhicule et
                remontée par une entrée «Tout ou Rien» ( ToR )
              </li>
              <li>
                Remontée des informations au central WiLiX
              </li>
              <li>
                Afficheur 5’’7 LCD couleur technologie TFT
                (Hors/En service, accès refusé, accès autorisé)
              </li>
            </ul>
          </Callout>

          <Callout title="Options disponibles">
            <ul>
              <li>
                Poste secondaire de phonie avec bouton poussoir
              </li>
              <li>
                Pied de fixation au sol
              </li>
              <li>
                Protection plexiglas pour extérieur
              </li>
              <li>
                Système BLE
              </li>
            </ul>
          </Callout>
          </Callout>
        </Card>
        break;
      default:
        description = null;
    }
    return (<Callout title={<Trans>prensentaion of the product line</Trans>}>
      <div className="flexbox-center">
        <Card
          interactive={true}
          onClick={() => this.setState({ selected: "CA" })}
          elevation={this.state.selected === "CA" ? Elevation.FOUR : 0}
          style={{ width: "25%" }}
        >
          <div className="flexbox-center">
            <H3 style={this.state.selected === "CA" ? { fontSize: 30 } : {}} ><Trans>CA</Trans></H3>
            <img
              src={this.state.selected === "CA" ? "/ow/view/pictures/gamme400/400CA1.webp" : "/ow/view/pictures/gamme400/400CA1.webp"}
              alt="CA gamme 400"
              style={{ width: 400 }}
            />
          </div>
        </Card>
        <Card
          interactive={true}
          onClick={() => this.setState({ selected: "BE" })}
          elevation={this.state.selected === "BE" ? Elevation.FOUR : 0}
          style={{ width: "25%" }}
        >
          <div className="flexbox-center">
            <H3 style={this.state.selected === "BE" ? { fontSize: 30 } : {}}><Trans>B</Trans></H3>
            <img
              src={this.state.selected === "BE" ? "/ow/view/pictures/gamme400/400BE1.webp" : "/ow/view/pictures/gamme400/400BE2.webp"}
              alt="BE gamme 400"
              style={{ width: 400 }}
            />
          </div>
        </Card>
        <Card
          interactive={true}
          onClick={() => this.setState({ selected: "LP" })}
          elevation={this.state.selected === "LP" ? Elevation.FOUR : 0}
          style={{ width: "25%" }}
        >
          <div className="flexbox-center">
            <H3 style={this.state.selected === "LP" ? { fontSize: 30 } : {}}><Trans>LP</Trans></H3>
            <img
              src={this.state.selected === "LP" ? "/ow/view/pictures/gamme400/400LP1.webp" : "/ow/view/pictures/gamme400/400LP2.webp"}
              alt="LP gamme 400"
              style={{ width: 400 }}
            />
          </div>
        </Card>
      </div>
      <br />
      {description}
    </Callout>);
  }
}